'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var utils = require('../utils-9a8db0ee.js');
var definitions = require('../definitions-0c162dc8.js');
var styleInject_es = require('../style-inject.es-71b52b81.js');
var lib = require('../lib-26f8f706.js');
require('../env-100217af.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css_248z = ".List {\n  display: flex;\n  flex: 1 1 auto;\n}\n\n.List--dir-x {\n  flex-direction: row;\n}\n\n.List--dir-y {\n  flex-direction: column;\n}\n\n.List--eq-children.List--eq-children > * {\n  flex: 1 0 0%;\n}\n";
styleInject_es.styleInject(css_248z);

var renderChildren = function (_a, children) {
    var direction = _a.direction, separator = _a.separator;
    if (!React__default["default"].isValidElement(separator)) {
        return children;
    }
    var renderedChildren = [];
    React__default["default"].Children.forEach(children, function (child, idx) {
        if (child === null || child === undefined) {
            return;
        }
        if (idx !== 0) {
            var separatorKey = "separator-" + idx;
            renderedChildren.push(React__default["default"].cloneElement(separator, {
                direction: direction,
                key: separatorKey,
                role: 'presentation',
            }));
        }
        renderedChildren.push(child);
    });
    return renderedChildren;
};
var directionToMarginPropName = {
    x: 'margin-left',
    y: 'margin-top',
};
var cssLengthToClassNameFragment = function (cssLength) {
    return cssLength.replace(/[.]/g, '-');
};
var isGapSupported = utils.isFlexGapSupported();
var name = 'List';
/**
 * Layout component that lays its children out in a line, either horizontally or vertically.
 */
function List(_a) {
    var _b = _a.container, container = _b === void 0 ? 'div' : _b, _c = _a.direction, direction = _c === void 0 ? definitions.Axis.X : _c, _d = _a.gap, gap = _d === void 0 ? 0 : _d, _e = _a.gapUnit, gapUnit = _e === void 0 ? definitions.LengthUnit.Rem : _e, _f = _a.equallySizedChildren, equallySizedChildren = _f === void 0 ? false : _f, children = _a.children, containerProps = _a.containerProps, className = _a.className, variant = _a.variant, separator = _a.separator, style = _a.style;
    var props = { className: className, variant: variant, separator: separator, direction: direction };
    React.useEffect(function () {
        if (gap === 0 || isGapSupported) {
            return;
        }
        utils.addGlobalStyleRule(".List--gap-" + cssLengthToClassNameFragment(gap + gapUnit) + ".List--dir-" + direction + " > *:not(:first-child) " +
            ("{ " + directionToMarginPropName[direction] + ": " + (gap + gapUnit) + " }"));
    }, [gap, gapUnit, direction]);
    var customStyle = React.useMemo(function () {
        return gap > 0 && isGapSupported ? tslib.__assign({ gap: gap + gapUnit }, style) : style;
    }, [gap, gapUnit, style]);
    var Container = container;
    return (React__default["default"].createElement(Container, tslib.__assign({}, containerProps, { className: lib.classNames(name, props, name + "--dir-" + direction, gap > 0 &&
            !isGapSupported &&
            name + "--gap-" + cssLengthToClassNameFragment(gap + gapUnit), equallySizedChildren && name + "--eq-children"), style: customStyle }), renderChildren(props, children)));
}

exports.List = List;
//# sourceMappingURL=index.js.map
